module.exports = __webpack_public_path__ + "catalog/items/chair/chair.png";